import { Sidebar, hideSidebar } from '@components/sidebar';

import { createJourneyActionFieldPath } from 'api/documents/requests';
import { useJourneyAction, useUpdateJourneyAction } from 'api/journey-actions/hooks';
import { ACTION_TYPES } from 'ui/actions/action-config';
import {
  ActionHeader,
  ActionSidebarLoading,
  SidebarProps,
} from 'ui/journey-builder/node-types/common';

import { UpdateFieldsFormContent } from './helpers';

const ACTION_TYPE = ACTION_TYPES.update_traveller;

export const SidebarContent = (props: SidebarProps) => {
  const { journeyActionId } = props;
  const { data, isLoading } = useJourneyAction<typeof ACTION_TYPE>(journeyActionId);
  const editMutation = useUpdateJourneyAction(journeyActionId);

  if (isLoading || !data) {
    return <ActionSidebarLoading actionType={ACTION_TYPE} {...props} />;
  }
  const filePath = createJourneyActionFieldPath(data.journey, journeyActionId);

  return (
    <Sidebar>
      <ActionHeader actionType={ACTION_TYPE} {...props} />
      <Sidebar.Content>
        <UpdateFieldsFormContent
          action={data}
          journeyId={data.journey}
          filePath={filePath}
          onCancel={hideSidebar}
          onSubmit={(data) =>
            editMutation.mutateAsync({
              isAutomatic: true,
              action: ACTION_TYPE,
              values: { fields: data.fields },
              description: data.description,
            })
          }
        />
      </Sidebar.Content>
    </Sidebar>
  );
};
